<template>
  <div class="detail_main">
    <el-page-header @back="goBack" content="详情页面"></el-page-header>
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="订单信息" name="first">
          <div class="main_index" v-if="false">
            <div class="header_tit">
              <p class="red_box"></p>
              <span>主订单信息</span>
            </div>
            <el-form label-width="100px" :model="orderDetailData" ref="orderDetailData">
              <el-form-item label="主订单号:" class="row_array">
                <span class="text">{{ orderDetailData.mainOrderNo }}</span>
                <el-button type="text" v-clipboard:copy="orderDetailData.mainOrderNo" v-clipboard:success="onCopy"
                  v-clipboard:error="onError">复制
                </el-button>
              </el-form-item>
              <el-form-item label="订单标识:" class="row_array">
                <span class="text">{{ orderDetailData.mainOrderMark }}</span>
              </el-form-item>
              <el-form-item label="用户ID:" class="row_array" v-if="$utils.hiddenFun()">
                <el-button @click="jumpDetail" type="text" size="mini">{{ orderDetailData.userId }}</el-button>
              </el-form-item>
              <el-form-item label="用户名称:" class="row_array">
                <span class="text">{{ orderDetailData.userName }}</span>
              </el-form-item>
              <el-form-item label="类型:" class="row_array">
                <span v-if="orderDetailData.userType == 0">默认</span>
                <span v-else-if="orderDetailData.userType == 1">商家</span>
                <span v-else-if="orderDetailData.userType == 2">客户</span>
              </el-form-item>
              <el-form-item label="下单时间:" class="row_array">
                <span class="text">{{ orderDetailData.createTime }}</span>
              </el-form-item>
              <el-form-item label="所属:" class="row_array" v-if="$utils.hiddenFun()">
                <span class="text">{{
                  orderDetailData.userParentName
                    ? orderDetailData.userParentName
                    : "无"
                }}</span>
              </el-form-item>
              <el-form-item label="留言:">
                <el-input v-model="orderDetailData.remark" type="textarea" style="width: 270px" :rows="2"
                  disabled></el-input>
              </el-form-item>
              <el-form-item label="运维备注:">
                <div>
                  <el-input type="textarea" v-model="orderDetailData.businessRemark"
                    style="width: 270px; margin-right: 30px;" :rows="2" placeholder="请输入运维备注"></el-input>
                  <!-- <el-button type="primary" @click="isShowPicInfoList = true">上传图片</el-button> -->
                </div>
                <!-- <div style="margin-top: 20px;" v-if="orderDetailData.picInfoList[0] || isShowPicInfoList">
                  <draggable :list="orderDetailData.picInfoList" :group="{ sort: true, animation: 500 }">
                    <div class="img_box" v-for="(item, index) in orderDetailData.picInfoList" :key="index">
                      <p class="del_box" @click.stop="handleDelPic(index)">
                        <img src="../../assets/del-icon.png" alt />
                      </p>
                      <img :src="item" alt @click.stop="handleBigPic(item)" />
                    </div>
                    <el-upload class="avatar-uploader border-one" action :show-file-list="false" :auto-upload="false"
                      :on-change="handleBusinessPic" multiple>
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </draggable>
                </div> -->
              </el-form-item>
              <!-- <el-form-item label="支付信息:" v-if="$utils.hiddenFun()">
                <el-table :data="tableData" border>
                  <el-table-column prop="payTradeNo" label="交易流水号" align="center" width="180"></el-table-column>
                  <el-table-column prop="totalAmount" label="订单金额" align="center"></el-table-column>
                  <el-table-column v-if="tableData.length && tableData[0]['lccwStorageFee'] !== undefined"
                    prop="lccwStorageFee" label="仓储费" align="center"></el-table-column>
                  <el-table-column prop="earnestMoney" label="定金金额" align="center"
                    v-if="orderDetailData.ispresell"></el-table-column>
                  <el-table-column prop="finalAmount" label="尾款金额" align="center"
                    v-if="orderDetailData.ispresell"></el-table-column>
                  <el-table-column prop="shippingFee" label="运费" align="center"></el-table-column>
                  <el-table-column prop="couponAmount" label="优惠券" align="center"></el-table-column>
                  <el-table-column prop="points" label="积分抵扣" align="center"></el-table-column>
                  <el-table-column prop="points" label="组合购优惠" align="center"></el-table-column>
                  <el-table-column prop="pledgeAmount" label="认筹抵扣" align="center"></el-table-column>
                  <el-table-column prop="envelopeAmount" label="红包抵扣" align="center"></el-table-column>
                  <el-table-column prop="fullReduceAmount" label="满减抵扣" align="center"></el-table-column>
                  <el-table-column prop="memberDiscountAmount" label="会员优惠" align="center"></el-table-column>
                  <el-table-column prop="paidFinalAmount" label="实付尾款金额" align="center"
                    v-if="orderDetailData.ispresell"></el-table-column>
                  <el-table-column prop="multipleDiscountAmount" label="多件多折" align="center"></el-table-column>
                  <el-table-column prop="productDiscountAmount" label="限时优惠" align="center"></el-table-column>
                  <el-table-column prop="deductibleMemberRebateAmount" label="盟友金抵扣" width="100"
                    align="center"></el-table-column>
                  <el-table-column prop="amount" label="实付金额" align="center"></el-table-column>
                  <el-table-column label="支付状态" align="center">
                    <template slot-scope="scope">
                      <span v-if="scope.row.isPaid">已支付</span>
                      <span v-else>未支付</span>
                    </template>
</el-table-column>
<el-table-column label="支付方式" align="center">

  <template slot-scope="scope">
                      <span v-if="scope.row.payType == 1">支付宝</span>
                      <span v-else-if="scope.row.payType == 2">微信</span>
                      <span v-else-if="scope.row.payType == 3">余额</span>
                    </template>
</el-table-column>
<el-table-column prop="payTime" label="支付时间" align="center">

  <template slot-scope="scope">
                      <span>{{ scope.row.payTime }}</span>
                    </template>
</el-table-column>
</el-table>
</el-form-item> -->
              <el-form-item>
                <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
              </el-form-item>
            </el-form>
          </div>
          <div class="sub_order">
            <div class="header_tit">
              <p class="red_box"></p>
              <span>子订单信息</span>
            </div>
            <div class="child_detail">
              <div class="child_detail_info" v-for="(item, index) in childOrderList" :key="index">
                <div class="info_tit">
                  <span style="margin-right:30px;">子订单{{ index + 1 }}</span>
                </div>
                <el-form label-width="100px">
                  <el-form-item label="子订单号:" style="margin-bottom: 10px">
                    <span class="text">{{ item.childOrderNo }}</span>
                  </el-form-item>
                  <el-form-item label="id:" style="margin-bottom: 10px">
                    <span class="text">{{ item.childOrderId }}</span>
                  </el-form-item>
                  <el-form-item label="订单状态:" style="margin-bottom: 10px; color: red">
                    <span class="text" v-if="item.status == 10">待支付</span>
                    <span class="text" v-if="item.status == 20">备货中</span>
                    <span class="text" v-if="item.status == 30">待收货</span>
                    <span class="text" v-if="item.status == 40">已收货</span>
                    <span class="text" v-if="item.status == 50">已完成</span>
                    <span class="text" v-if="item.status == 60">取消</span>
                    <span class="text" v-if="item.status == 70">已关闭</span>
                  </el-form-item>
                  <el-form-item label="商品ID:" style="margin-bottom: 10px;cursor: pointer;">
                    <span @click="jumpToProduct(item.spuId)" class="text">{{ item.spuId }}</span>
                  </el-form-item>
                  <el-form-item label="商品名称:" style="margin-bottom: 10px">
                    <span class="text">{{ item.skuName }}</span>
                  </el-form-item>
                  <el-form-item label="商品规格:" style="margin-bottom: 10px">
                    <span class="text">{{ item.skuSpecificationExt ? item.skuSpecificationExt : item.skuSpecification
                    }}</span>
                  </el-form-item>
                  <!-- <el-form-item label="销售价格:" style="margin-bottom: 10px">
                    <p>单价：￥{{ item.skuPrice }}</p>
                    <p>合计：￥{{ parseFloat(item.skuPrice * item.skuNumber).toFixed(2) }}</p>
                  </el-form-item> -->
                  <el-form-item label="结算价格:" style="margin-bottom: 10px">
                    <p>单价：￥{{ item.skuBillPrice }}</p>
                    <p>合计：￥{{ settlePrice(item) }}</p>
                  </el-form-item>
                  <el-form-item label="购买数量:" style="margin-bottom: 10px">
                    <span>{{ item.skuNumber }}</span>
                  </el-form-item>
                  <!-- <el-form-item label="退款(返):" style="margin-bottom: 10px" v-if="item.orderRebateInfo">
                    <span style="margin-right:20px;" v-if="item.orderRebateInfo.status == 2">￥{{
                      item.orderRebateInfo.amount }}</span>
                    <el-tag effect="plain" size="mini" v-if="item.orderRebateInfo.status == 2">已打款</el-tag>
                    <el-tag effect="plain" size="mini" type="danger" v-if="item.orderRebateInfo.status == 1">待打款
                    </el-tag>
                  </el-form-item> -->
                  <el-form-item label="收货信息:" style="margin-bottom: 10px"
                    v-show="item.status == 20 || item.status == 30">
                    <div>
                      <p>{{ item.receiverName }}--{{ item.receiverPhone }}</p>
                      <p>
                        {{ item.receiverProvinceName }} -
                        {{ item.receiverCityName }} -
                        {{ item.receiverDistrictName }} -
                        {{ item.receiverStreetName }} -
                        {{ item.receiverAddress }}
                      </p>
                    </div>
                  </el-form-item>
                  <el-form-item label="留言：">
                    <div>{{ item.remark }}</div>
                  </el-form-item>
                </el-form>
                <div v-if="item.supLogisticsList">
                  <div class="info_tit">
                    <span>物流信息</span>
                  </div>
                  <div class="sup-box" v-for="(sup, supid) in item.supLogisticsList" :key="supid">
                    <p>
                      <span>供货商：{{ sup.buySupplierName }}</span>
                      <span style="margin:0 10px 0 20px;">已发：{{ sup.totalSendSkuNumer }}</span>
                      <span style="margin:0 10px 0 0;">可发：{{ sup.canSendNumber }}</span>
                      <el-button size="mini" type="success" v-preventClick v-if="sup.canSendNumber > 0"
                        @click="fahuo(sup, item)">发货
                      </el-button>
                    </p>
                    <div class="log-box" v-for="(log, logId) in sup.logisticsList" :key="logId">
                      <p>
                        <span style="margin-right:20px;">物流公司：{{ log.logisticsCompanyName }}</span>
                        <el-button plain size="mini" type="success" @click="handleLookLog(log)">查看物流</el-button>
                      </p>
                      <p><span>物流单号：{{ log.logisticsCode }}</span></p>
                      <p><span>外部订单号：{{ log.outChildOrderNo }}</span></p>
                      <p><span>发货数量：{{ log.sendSkuNumer }}</span></p>
                      <p v-if="log.logisticsNote"><span>备注信息：{{ log.logisticsNote }}</span></p>
                    </div>
                  </div>
                </div>
                <div v-if="item.afterSaleList[0]">
                  <div class="info_tit">
                    <span>退换货</span>
                  </div>
                  <el-form label-width="100px">
                    <el-form-item label="退换货类型:" style="margin-bottom: 10px; float: left; width: 200px">
                      <span v-if="item.afterSaleList[0].type == 1">退款</span>
                      <span v-else-if="item.afterSaleList[0].type == 2">退货</span>
                      <span v-else-if="item.afterSaleList[0].type == 3">换货</span>
                    </el-form-item>
                    <el-form-item label="数量:" style="margin-bottom: 10px; float: left; width: 200px">
                      <span>{{ item.afterSaleList[0].applySkuNumber }}</span>
                    </el-form-item>
                    <div v-if="item.afterSaleList[0].type !== 3">
                      <el-form-item label="退款金额:" style="margin-bottom: 10px; float: left; width: 200px">
                        <span>￥{{ item.afterSaleList[0].refundAmount }}</span>
                      </el-form-item>
                      <el-form-item label="实际退款金额:" style="margin-bottom: 10px; float: left; width: 200px">
                        <span>￥{{ item.afterSaleList[0].actualRefundAmount }}</span>
                      </el-form-item>
                      <el-form-item label="退款状态:" style="margin-bottom: 10px;clear: both;">
                        <span v-if="item.afterSaleList[0].refundStatus == 0">未退款</span>
                        <span v-else-if="item.afterSaleList[0].refundStatus == 1">已退款</span>
                        <span v-else-if="item.afterSaleList[0].refundStatus == 2">退款失败</span>
                      </el-form-item>
                      <el-form-item label="退款时间:" style="margin-bottom: 10px">
                        <span>{{ item.afterSaleList[0].refundTime }}</span>
                      </el-form-item>
                    </div>
                    <el-form-item label-width="0">
                      <hr>
                      <p>退款总金额：￥{{ item.refundAmount }} 退款总数量：{{ item.refundNumber }}</p>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- 发货 -->
    <el-dialog title="发货" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <el-form ref="logForm" :model="logForm" label-width="120px" style="background: none">
        <el-form-item label="供应商">
          <span>{{ tempData.buySupplierName }}</span>
        </el-form-item>
        <el-form-item label="物流公司">
          <el-select v-model="logForm.logisticsCompanyId" filterable placeholder="请选择物流公司">
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.shortName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input class="flex-1" placeholder="输入物流单号" v-model="logForm.logisticsCode" @change="getLogisticsByNumber">
          </el-input>
        </el-form-item>
        <el-form-item label="当前发货数量">
          <div>
            <el-input v-model="logForm.sendSkuNumber" @input="watchInput"></el-input>
          </div>
          <div>
            <span style="margin-left:30px;">已发货{{ tempData.sendSkuNumber }}</span>
            <span style="margin-left:30px;">未发货{{ tempData.canSendNumber }}</span>
          </div>
        </el-form-item>
        <el-form-item label="外部订单号">
          <el-input v-model="logForm.outChildOrderNo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-preventClick @click="handleSendSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog title="修改物流" :visible.sync="reviseVisible" width="30%" :close-on-click-modal="false">
      <el-form ref="reviseForm" :model="reviseForm" label-width="120px" style="background: none">
        <el-form-item label="物流公司">
          <el-select v-model="reviseForm.logisticsCompanyId" filterable placeholder="请选择物流公司">
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.ShortName"
              :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="reviseForm.logisticsCode"></el-input>
        </el-form-item>
        <!-- <el-form-item label="发货数量">
          <span>{{tempData.canSendNumber}}</span>
        </el-form-item> -->
        <el-form-item label="当前发货数量">
          <el-input v-model="reviseForm.sendSkuNumer"></el-input>
        </el-form-item>
        <el-form-item label="外部订单号">
          <el-input v-model="reviseForm.outChildOrderNo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reviseVisible = false">取 消</el-button>
        <el-button type="primary" v-preventClick @click="handleReviseSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 物流信息 -->
    <el-dialog title="物流信息" width="50%" :visible.sync="showLogVisible" :close-on-click-modal="false">
      <div v-for="(item, index) in logDescriptionList" class="item_li" :key="index">
        <span>{{ item.description }}</span>
        <span>{{ item.time }}</span>
      </div>
      <div v-if="!logDescriptionList[0]">暂无物流信息</div>
    </el-dialog>
    <!-- 退款 -->
    <el-dialog title="退款" :visible.sync="returnVisible" width="40%" :close-on-click-modal="false">
      <el-form label-width="140px" style="background: none" v-if="returnVisible">
        <el-form-item label-width="0"
          v-if="fullReduceData.IsJoinChannelFullReduceActivity && fullReduceData.TipsMessage">
          <span style="color:#f40000;">{{ fullReduceData.TipsMessage }}</span>
        </el-form-item>
        <el-form-item label-width="0"
          v-if="fullReduceData.IsJoinChannelFullReduceActivity && fullReduceData.DeductDiscountAmount">
          <span style="color:#f40000;">该商品参加满减活动，退款后该主订单金额不满足满减条件，需扣除优惠金额</span>
        </el-form-item>
        <el-form-item label="订单实付金额:">
          <span>￥{{ fullReduceData.ActualPayAmount }}</span>
        </el-form-item>
        <el-form-item label="订单金额：" v-if="fullReduceData.IsJoinChannelFullReduceActivity">
          <span>￥{{ fullReduceData.OrderAmount }}</span>
        </el-form-item>
        <el-form-item label="需扣除的优惠金额：" v-if="fullReduceData.IsJoinChannelFullReduceActivity">
          <span>￥{{ fullReduceData.DeductDiscountAmount }}</span>
        </el-form-item>
        <el-form-item label="购买数量:">
          <span>{{ receiveRow.skuNumber }}</span>
        </el-form-item>
        <el-form-item label="退款数量:">
          <span>{{ fullReduceData.applySkuNumber }}</span>
        </el-form-item>
        <el-form-item label="实际退款金额:">
          <span>￥{{ fullReduceData.actualRefundAmount }}</span>
        </el-form-item>
        <!-- <el-form-item label="实际退款金额:">
          <el-input
            v-model="returnForm.refundAmount"
            type="number"
            placeholder="请输入退款金额"
            @input="testRefundAmount"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="备注:">
          <el-input v-model="returnForm.reason" placeholder="请输入备注内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="returnVisible = false">取 消</el-button>
        <el-button type="primary" v-preventClick @click="handleReturnSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 退货 -->
    <el-dialog title="退货" :visible.sync="applyReturnVisible" width="40%" :close-on-click-modal="false">
      <el-form label-width="140px" style="background: none" v-if="returnRow">
        <el-form-item label-width="0"
          v-if="fullReduceData.IsJoinChannelFullReduceActivity && fullReduceData.TipsMessage">
          <span style="color:#f40000;">{{ fullReduceData.TipsMessage }}</span>
        </el-form-item>
        <el-form-item label-width="0"
          v-if="fullReduceData.IsJoinChannelFullReduceActivity && fullReduceData.DeductDiscountAmount">
          <span style="color:#f40000;">该商品参加满减活动，退款后该主订单金额不满足满减条件，需扣除优惠金额</span>
        </el-form-item>
        <el-form-item label="退货数量:">
          <span>{{ fullReduceData.applySkuNumber }}</span>
        </el-form-item>
        <el-form-item label="货物状态:">
          <el-select v-model="applyReturnForm.productStatus" placeholder="请选择状态">
            <el-option :value="1" label="已收到货"></el-option>
            <el-option :value="2" label="未收到货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款金额:">
          <span>￥{{ fullReduceData.OrderAmount }}</span>
        </el-form-item>
        <el-form-item label="需扣除的优惠金额：" v-if="fullReduceData.IsJoinChannelFullReduceActivity">
          <span>￥{{ fullReduceData.DeductDiscountAmount }}</span>
        </el-form-item>
        <el-form-item label="实际退款金额：">
          <span>￥{{ fullReduceData.actualRefundAmount }}</span>
        </el-form-item>
        <!-- <el-form-item label="实际退款金额:">
          <el-input
            v-model="applyReturnForm.refundAmount"
            type="number"
            placeholder="请输入退款金额"
            @input="testReturnAmount"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="备注:">
          <el-input v-model="applyReturnForm.reason" placeholder="请输入备注内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyReturnVisible = false">取 消</el-button>
        <el-button type="primary" v-preventClick @click="handleApplyReturnSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 换货 -->
    <el-dialog title="换货" :visible.sync="applyChangeVisible" width="30%" :close-on-click-modal="false">
      <el-form label-width="120px" style="background: none" v-if="changeRow">
        <el-form-item label="换货数量:">
          <span v-if="changeRow.skuNumber == 1">{{ changeRow.skuNumber }}</span>
          <el-input v-else v-model="changeForm.applySkuNumber" type="number" placeholder="请输入退货数量"
            @input="testChangeNumber"></el-input>
        </el-form-item>
        <el-form-item label="货物状态:">
          <el-select v-model="changeForm.productStatus" placeholder="请选择状态">
            <el-option :value="1" label="已收到货"></el-option>
            <el-option :value="2" label="未收到货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="changeForm.reason" placeholder="请输入备注内容"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="applyChangeVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleChangeSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 赠品 -->
    <el-dialog title="赠品发放情况" :visible.sync="showGiftLayer" width="40%" :close-on-click-modal="false">
      <el-tabs tab-position="left">
        <el-tab-pane :label="index + 1" v-for="(item, index) in giftList" :key="index">
          <el-form label-width="120px" style="background: none">
            <el-form-item label="赠品名称:">
              <span>{{ item.GiftName }}</span>
            </el-form-item>
            <el-form-item label="总赠送次数:">
              <span>{{ item.TotalGiftCount }}</span>
            </el-form-item>
            <el-form-item label="已赠送数量:">
              <span>{{ item.HaveGiftNumber }}</span>
            </el-form-item>
            <el-form-item label="总赠送数量:">
              <span>{{ item.TotalGiftCount }}</span>
            </el-form-item>
            <el-form-item label="已赠送次数:">
              <span>{{ item.HaveGiftCount }}</span>
            </el-form-item>
            <el-form-item label="每次赠送时间:">
              <p v-for="(itm, idx) in item.recordDatas" :key="idx">{{ itm.GetTime }}领取了{{ itm.CurrentGiftNumber }}个</p>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 退款/退货数量 -->
    <el-dialog width="30%" center :visible.sync="dialogSkuNumber" :close-on-click-modal="false">
      <div style="text-align: center;">
        <span style="margin-right:10px;">退款/退货数量:</span>
        <el-input v-model.number="needData.applySkuNumber" @input="watchApplySkuNumber"></el-input>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="confirmBtn">确认</el-button>
        <el-button @click="dialogSkuNumber = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 订单情况 -->
    <el-dialog title="订单情况" center width="80%" :visible.sync="dialogVisible2" :close-on-click-modal="false">
      <div class="flex-wrap">
        <div class="flex-1">
          <h3>节点跟踪</h3>
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.timestamp">
              {{ activity.content }}
              <div class="case-box">
                <div>
                  <div style="display: flex">
                    <div style="margin-right: 20px">
                      {{ activity.OperatorName }}
                    </div>
                    <div>
                      <p>
                        <span style="margin-right: 20px">{{
                          activity.OperateName
                        }}</span>
                      </p>
                      <p v-if="activity.operateType == 490">
                        <span>问题分类：{{
                          JSON.parse(activity.remark).Type | typeName
                        }}</span>&nbsp;&nbsp;&nbsp;
                        <span>跟进状态：{{
                          JSON.parse(activity.remark).ProcessStatus
                          | processStatusName
                        }}</span>&nbsp;&nbsp;&nbsp;
                        <span>备注：{{ JSON.parse(activity.remark).remark }}</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div>{{ activity.createTime }}</div>
                <div v-if="activity.remark">备注：{{ activity.remark }}</div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <div class="flex-1">
          <h3 style="margin-bottom:20px">聊天信息</h3>
          <el-timeline>
            <el-timeline-item v-for="(item, index) in chatSyncList" :key="index">
              <div class="case-box">
                <div>
                  <div v-if="item.MsgType === 1" class="messageList-text">{{ item.FromUserName }}：{{ item.MsgContent }}
                  </div>
                  <!-- 图片 -->
                  <div v-else-if="item.MsgType === 2">
                    <div class="messageList-text">{{ item.FromUserName }}：</div>
                    <el-image style="max-width: 200px;border-radius: 10px;" :src="item.MsgContent"
                      :preview-src-list="chatSyncList.filter(img => img.MsgType === 2).map(url => { return url.MsgContent })">
                    </el-image>
                  </div>
                  <!-- 富文本 -->
                  <div v-else-if="item.MsgType === 5">
                    <div class="messageList-text">{{ item.FromUserName }}：</div>
                    <div class="messageList-text message-richText" v-html="item.MsgContent"
                      @click="richTextClick($event)" />
                  </div>
                  <!-- 商品 -->
                  <div v-else-if="item.MsgType === 6">
                    <div class="messageList-text">{{ item.FromUserName }}：</div>
                    <div class="messageList-product flex-wrap">
                      <img :src="item.Product.ProMainPic" alt="" class="messageList-product-img">
                      <div class="flex-1 flex-sb flex-wrap flex-col">
                        <p class="messageList-product-proName">{{ item.Product.ProName }}</p>
                        <p class="messageList-product-price">¥{{ item.Product.Price }}</p>
                      </div>
                    </div>
                  </div>
                  <!--订单 -->
                  <div v-else-if="item.MsgType === 7">
                    <div class="messageList-text">{{ item.FromUserName }}：</div>
                    <div class="messageList-product messageList-order">
                      <div class="flex-wrap flex-center flex-sb">
                        <p class="message-order-childOrderNo">{{ item.Order.childOrderNo }}</p>
                        <p class="message-order-statusDesc">{{ item.Order.statusDesc }}</p>
                      </div>
                      <div class="flex-wrap" style="margin-top: 10px;">
                        <img :src="item.Order.ProMainPic" alt="" class="messageList-product-img">
                        <div class="flex-1 flex-wrap flex-sb flex-col">
                          <div class="flex-wrap">
                            <p class="flex-1 messageList-product-proName">{{ item.Order.proName }}</p>
                            <div style="margin-left: 10px;">
                              <p class="messageList-product-proName textR">¥{{ item.Order.skuPrice }}</p>
                              <p class="message-order-childOrderNo textR">x{{ item.Order.skuNumber }}</p>
                            </div>
                          </div>
                          <p class="textR messageList-product-price">合计¥{{ item.Order.amount }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 视频 -->
                  <div v-else-if="item.MsgType === 8">
                    <div class="messageList-text">{{ item.FromUserName }}：</div>
                    <video :src="item.MsgContent" controls style="max-width: 200px;border-radius: 10px;"></video>
                  </div>
                </div>
                <div>{{ item.MsgSendTime }}</div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </el-dialog>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogBigImgVisible">
      <img style="width:100%;" :src="dialogImageUrl" alt="">
    </el-dialog>
    <!--子订单状态更改弹框-->
    <el-dialog title="子订单状态设置" :visible.sync="subOrderVisible" :close-on-click-modal=false :close-on-press-escape=false
      :show-close=false width="30%" center>
      <el-form>
        <el-form-item label="订单号">
          <el-input :disabled="true" v-model="subChildOrder.orderNo"></el-input>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select @change="selectSubOrderStatus" v-model="subChildOrder.status" placeholder="请选择订单状态">
            <el-option v-for="item in subOrderOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作时间：">
          <el-date-picker :clearable="true" v-model="subChildOrder.operationTime" type="datetime" placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="是否分红" v-if="isSubOrderChoseShow">
          <el-radio-group v-model="subChildOrder.isBonus">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="subOrderClose">取 消</el-button>
        <el-button type="primary" @click="subOrderConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 海信推送 -->
    <el-dialog title="海信推送" :visible.sync="isHaiXinShow" :show-close=false :close-on-press-escape=false
      :close-on-click-modal="false">
      <el-form id="hxSend">
        <el-form-item label="是否推送">
          &nbsp;&nbsp;&nbsp;&nbsp; <label>{{ showHaiXinData.IsSend === true ? '是' : '否' }}</label>
        </el-form-item>
        <el-form-item label="是否自动采购">
          &nbsp;&nbsp;&nbsp;&nbsp; <label>{{ showHaiXinData.IsPurchaserSuccess === true ? '成功' : '失败' }}</label>
        </el-form-item>
        <el-form-item label="采购错误消息">
          &nbsp;&nbsp;&nbsp;&nbsp;
          <label>{{ showHaiXinData.IsPurchaserSuccess === true ? '' : showHaiXinData.PurchaserErrorMsg }}</label>
        </el-form-item>
        <el-form-item label="是否推送">
          &nbsp;&nbsp;&nbsp;&nbsp; <label>{{ showHaiXinData.IsSendSuccess === true ? '成功' : '失败' }}</label>
        </el-form-item>
        <el-form-item label="推送错误消息">
          &nbsp;&nbsp;&nbsp;&nbsp; <label>{{
            showHaiXinData.IsSendSuccess === true ? '' : showHaiXinData.SendErrorMsg
          }}</label>
        </el-form-item>
        <el-form-item label=" 推送次数">
          &nbsp;&nbsp;&nbsp;&nbsp; <label>{{ showHaiXinData.Count }}</label>
        </el-form-item>
        <el-form-item label="重新推送订单号">
          &nbsp;&nbsp;&nbsp;&nbsp; <label>{{ showHaiXinData.NewChildOrderNos }}</label>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="isHaiXinShow = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 订单补偿 -->
    <el-dialog width="30%" title="订单补偿" :visible.sync="visibleCompensate" :close-on-press-escape=false
      :close-on-click-modal="false">
      <el-form>
        <el-form-item label="选择优惠券">
          <el-select style="width: 300px" v-model="compensateCouponId">
            <el-option :label="'(' + coupon.id + ') ' + coupon.name" :value="coupon.id"
              v-for="(coupon, i) in compensateCoupons" :key="i"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCompensate">确定</el-button>
      </div>
    </el-dialog>
    <!-- 安装返豆 -->
    <el-dialog width="30%" title="盟友豆申请" :visible.sync="visibleInstallBean" :close-on-press-escape=false
      :close-on-click-modal="false">
      <el-form>
        <el-form-item label="盟友豆数量：">
          <el-input v-model="beanForm.memberRebateAmount"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="beanForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleReturnBean">确定</el-button>
      </div>
    </el-dialog>
    <!-- 附件物流 -->
    <el-dialog title="附件物流" width="80%" :visible.sync="dialogAnnexLogistics">
      <el-table border :data="annexList">
        <el-table-column label="物流单号" prop="logisticsNo" align="center"></el-table-column>
        <el-table-column label="选择物流公司" prop="logisticsCompanyName" align="center"></el-table-column>
        <el-table-column label="本次货品数量" prop="currentShipmentQuantity" align="center"></el-table-column>
        <el-table-column label="备注信息" prop="logisticsNote" align="center"></el-table-column>
        <!-- <el-table-column label="物流单号/物流公司" align="center">
          <template slot-scope="scope">
            <div class="flex-wrap">
              <el-input class="flex-1" placeholder="输入物流单号" v-model="scope.row.logisticsNo"></el-input>
              <el-autocomplete class="flex-1" v-model="scope.row.logisticsCompanyName" :fetch-suggestions="querySearchAsync"
                          placeholder="选择物流公司" @select="(value)=>handleSelect(value, scope.row)"></el-autocomplete>
              <el-input class="flex-1" placeholder="本次货品数量" v-model.number="scope.row.currentShipmentQuantity"></el-input>
              <el-input class="flex-1" placeholder="输入备注信息" v-model="scope.row.logisticsNote"></el-input>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
    </el-dialog>
    <!-- 查看更多退换货 -->
    <el-dialog :visible.sync="dialogAfterSaleVisible" :close-on-press-escape="false">
      <el-table border :data="afterSaleList">
        <el-table-column label="退换货类型" prop="" align="center">

          <template slot-scope="scope">
            <span v-if="scope.row.Type == 1">退款</span>
            <span v-else-if="scope.row.Type == 2">退货</span>
            <span v-else-if="scope.row.Type == 3">换货</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="applySkuNumber" align="center"></el-table-column>
        <el-table-column label="退款金额" prop="refundAmount" align="center"></el-table-column>
        <el-table-column label="实际退款金额" prop="actualRefundAmount" align="center"></el-table-column>
        <el-table-column label="退款状态" prop="" align="center">

          <template slot-scope="scope">
            <span v-if="scope.row.refundStatus == 0">未退款</span>
            <span v-else-if="scope.row.refundStatus == 1">已退款</span>
            <span v-else-if="scope.row.refundStatus == 2">退款失败</span>
          </template>
        </el-table-column>
        <el-table-column label="退款时间" prop="refundTime" align="center" width="200"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  KSAXApiRequest,
  GetOrderLogisticsKSAX,


  mainOrderDetail,
  areaList,
  childList,
  editMainOrder,
  mainOrderTrack,
  logisticsCompanyAllList,
  logistics,
  reviseLogistics,
  receipt,
  applyRefund,
  applyReturn,
  applyChange,
  purList,
  purListV2,
  GetGiftRecordDatas,
  CalculateRefundAmount,
  GetBalanceCanRefundNum,
  ChildSupShip,
  GetOrderTrackList,
  getQiniuToken,
  ChangeOrderStatus,
  GetHxRecordInfo,
  OverTimeCompensate,
  MemberRebateOrderCreate,
  ChatSyncOrderList
} from "../../api/api";
import draggable from "vuedraggable";
// import workOrder from "./workOrder";
import { getButtonList } from "../../promissionRouter";
import toolbar from "../../components/Toolbar";

export default {
  watch: {
    activeName() {
      this.pageIndex = 1;
    },
  },
  components: {
    toolbar, draggable,
    // workOrder
  },
  data() {
    return {
      qiniuToken: '',
      activeName: "first",
      orderDetailData: {
        mainOrderId: 0,
        receiverName: "",
        receiverPhone: "",
        receiverProvinceId: 0,
        receiverCityId: 0,
        receiverDistrictId: 0,
        receiverAddress: "",
        remark: "",
        businessRemark: "",
        picInfoList: []
      },
      total: 0,
      trackList: [],
      buttonList_toolBar: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      childOrderList: [],
      provinceList: [], //省
      cityList: [], //市
      areaList: [], //区
      //   发货字段
      logisticsList: [],
      dialogVisible: false,
      logForm: {
        childOrderId: 0,
        logisticsCompanyId: null,
        logisticsCode: "",
        buySupplierId: null,
        sendSkuNumber: null,
        outChildOrderNo: null
      },
      //退款字段
      receiveRow: null,
      returnForm: {
        childOrderId: 0,
        refundAmount: 0,
        reason: "",
        applySkuId: 0,
        applySkuNumber: 1
      },
      returnVisible: false,

      //退货字段
      applyReturnVisible: false,
      returnRow: null,
      applyReturnForm: {
        childOrderId: 0,
        applySkuId: 0,
        applySkuNumber: 1,
        refundAmount: null,
        reason: "",
        productStatus: null,
      },

      // 换货字段
      applyChangeVisible: false,
      changeRow: null,
      changeForm: {
        childOrderId: 0,
        applySkuId: 0,
        productStatus: 1,
        applySkuNumber: 1,
        reason: "",
      },

      //修改物流
      reviseVisible: false,
      reviseForm: {
        orderLogisticsId: 0,
        logisticsCompanyId: null,
        logisticsCode: "",
        sendSkuNumer: null,
        outChildOrderNo: null
      },

      //查看物流
      showLogVisible: false,
      logDescriptionList: [],

      isShowDeliver: false,
      isShowRefund: false,
      isShowConfirm: false,
      isShowReturn: false,
      isShowRevise: false,
      isShowLookLog: false,
      isShowExchange: false,
      isShowGiftDetail: false,
      showGiftLayer: false,

      itemData: null,
      refundVisible: false,
      returnsVisible: false,
      changeVisible: false,

      giftList: [],
      purRecList: [],
      fullReduceData: {},
      balanceCanRefundNum: 1,
      dialogSkuNumber: false,
      needData: {
        operateType: null,
        childOrderNo: null,
        applySkuNumber: 1
      },
      tempData: {},
      dialogVisible2: false,
      activities: [],
      chatSyncList: [],
      dialogBigImgVisible: false,
      dialogImageUrl: '',
      isShowPicInfoList: false,
      subOrderVisible: false,
      subOrderOptions: [{
        value: '10',
        label: '待付款'
      }, {
        value: '20',
        label: '备货中'
      }, {
        value: '30',
        label: '已发货'
      }, {
        value: '40',
        label: '已收货'
      }, {
        value: '50',
        label: '已完成'
      }, {
        value: '60',
        label: '已取消'
      }, {
        value: '70',
        label: '已关闭'
      }],
      subChildOrder: {
        status: '', //订单状态
        isBonus: true,  // 分红
        operationTime: new Date(),  //日期
        orderNo: '' // 订单号
      },
      isSubOrderChoseShow: false,
      isSubOrderShow: false, // 子订单详情修改 订单按钮  权限
      isHaiXinShow: false,
      showHaiXinData: '', // 展示海信信息

      isCompensateBtn: false, // 补偿按钮权限
      visibleCompensate: false,
      compensateItem: null,
      compensateCouponId: null,
      compensateCoupons: [
        { id: 988, name: '货品补偿100元B' },
        { id: 987, name: '货品补偿80元B' },
        { id: 986, name: '货品补偿50元B' },
        { id: 985, name: '货品补偿20元B' },
        { id: 984, name: '货品补偿80元A' },
        { id: 983, name: '货品补偿50元A' },
        { id: 982, name: '货品补偿20元A' },
        { id: 981, name: '货品补偿10元A' },
        { id: 980, name: '订单补偿100元' },
        { id: 979, name: '订单补偿80元' },
        { id: 978, name: '订单补偿50元' },
        { id: 977, name: '订单补偿30元' },
        { id: 976, name: '订单补偿20元' },
        { id: 975, name: '订单补偿10元' }
      ],
      isCanReturnBean: false,
      visibleInstallBean: false,
      beanForm: {
        memberRebateAmount: null,
        target: null,
        remark: null
      },
      annexList: [], // 附件物流
      dialogAnnexLogistics: false,
      dialogAfterSaleVisible: false,
      afterSaleList: []
    };
  },
  created() {
    this.getMainOrderDetail();
    // this.getProvinceList();
    this.getChildList();
    this.getQiniuToken();
  },
  methods: {
    settlePrice(item) {
      if (item.afterSaleList && item.afterSaleList[0]) {
        return parseFloat(item.skuBillPrice * (item.skuNumber - item.afterSaleList[0].applySkuNumber)).toFixed(2)
      } else {
        return parseFloat(item.skuBillPrice * item.skuNumber).toFixed(2)
      }
    },
    getLogisticsByNumber() {
      let data = {
        path: 'Business_UserManager/GetLogisticsByNumber',
        parms: `code=${this.logForm.logisticsCode}`
      }
      KSAXApiRequest(data).then(res => {
        if (res.data.success) {
          this.logForm.logisticsCompanyId = res.data.response.id
        }
      })
    },
    lookMore(arr) {
      this.dialogAfterSaleVisible = true
      this.afterSaleList = arr
    },
    jumpDetail() {
      if (this.orderDetailData.userType == 1) {
        this.$router.push(`/UserCenter/Distributor/DistributorDetial?Id=${this.orderDetailData.userId}`)
      } else if (this.orderDetailData.userType == 2) {
        this.$router.push(`/UserCenter/CEndUser/CuserDetail?Id=${this.orderDetailData.userId}`)
      }
    },
    jumpToProduct(spuId) {
      window.open(`/Product/ComManagement/AddEditSpu?id=${spuId}`);
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    handleBusinessPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic;
          if (that.orderDetailData.picInfoList[0]) {
            itemPic = res
          } else {
            itemPic = res
          }
          that.orderDetailData.picInfoList.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleBigPic(src) {
      this.dialogBigImgVisible = true;
      this.dialogImageUrl = src;
    },
    handleDelPic(index) {
      let that = this;
      that.orderDetailData.picInfoList.splice(index, 1);
    },
    orderTrack(item) {
      let data = {}
      data.childOrderId = item.childOrderId
      this.dialogVisible2 = true;
      this.getOrderTrackList(data)
      this.getChatSyncOrderList(data)
    },
    getOrderTrackList(data) {
      GetOrderTrackList(data).then((res) => {
        if (res.data.success) {
          // this.dialogVisible2 = true;
          this.activities = res.data.response || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getChatSyncOrderList(data) {
      let param = {
        childOrderId: data.childOrderId,
        pageIndex: 1,
        pageSize: 100
      }
      ChatSyncOrderList(param).then((res) => {
        if (res.data.success) {
          // this.dialogVisible2 = true;
          this.chatSyncList = res.data.response.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    orderCompensate(item) {
      this.compensateItem = item
      this.visibleCompensate = true
      // this.$confirm("确认补偿吗?", "提示", {
      //   closeOnClickModal: false,
      // }).then(() => {
      //   OverTimeCompensate({childOrderId: item.childOrderId}).then(res => {
      //     if (res.data.success) {
      //       this.getChildList()
      //     } else {
      //       this.$message.error(res.data.msg);
      //     }
      //   })
      // })
      // .catch(() => {})
    },
    installReturnBean(item) {
      this.beanForm.target = item.childOrderNo
      this.visibleInstallBean = true
    },
    handleReturnBean() {
      if (!this.beanForm.memberRebateAmount) {
        return this.$message.error("请填写盟友豆数量！")
      }
      let data = {
        operatingType: 1,
        targetType: 2,
        items: [this.beanForm]
      }
      MemberRebateOrderCreate(data).then(res => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.visibleInstallBean = false
          this.beanForm = {
            memberRebateAmount: null,
            target: null,
            remark: null
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleCompensate() {
      if (!this.compensateCouponId) {
        return this.$message.error('请选择优惠券')
      }
      OverTimeCompensate({
        childOrderId: this.compensateItem.childOrderId,
        couponId: this.compensateCouponId
      }).then(res => {
        if (res.data.success) {
          this.getChildList()
          this.visibleCompensate = false
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    watchInput(val) {
      if (val <= 0) {
        this.logForm.sendSkuNumber = 1
      } else if (val > this.tempData.canSendNumber) {
        this.logForm.sendSkuNumber = this.tempData.canSendNumber
      }
    },
    fahuo(row, pRow) {
      if (!pRow.confirmSourceType) {
        this.$alert('该订单未确认货源，无法进行发货，请先确认货源！', '提示', {
          confirmButtonText: '确定',
          callback: action => {
          }
        });
        // this.$alert('该订单未确认货源，无法进行发货，请先确认货源！', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning',
        //   customClass: 'mConfirmSourceWin'
        // }).then(() => {
        //   this.confirmSource(pRow)
        // }).catch(() => { });
      } else {
        this.dialogVisible = true
        this.tempData.buySupplierName = row.buySupplierName
        this.tempData.surplusSendNumber = row.SurplusSendNumber
        this.tempData.canSendNumber = row.canSendNumber
        this.tempData.sendSkuNumber = row.totalSendSkuNumer
        this.tempData.reverseNumber = row.reverseNumber
        this.logForm = {
          childOrderId: row.childOrderId,
          buySupplierId: row.buySupplierId,
          logisticsCompanyId: null,
          logisticsCode: "",
          sendSkuNumber: null,
          outChildOrderNo: null
        }
        let data = {
          path: 'LogisticsCompany/AllList',
          parmsJson: {
            SearchKey: ''
          }
        }
        KSAXApiRequest(data).then((res) => {
          this.logisticsList = res.data.response
        });
      }
    },
    confirmBtn() {
      this.getIsJoinChannelFullReduce()
    },
    watchApplySkuNumber(e) {
      if (e <= 0) {
        this.needData.applySkuNumber = 1;
      } else if (e > this.balanceCanRefundNum) {
        this.needData.applySkuNumber = this.balanceCanRefundNum;
      }
    },
    getBalanceCanRefundNum(val) {
      GetBalanceCanRefundNum({
        childOrderNo: val.childOrderNo
      }).then(res => {
        if (res.data.success) {
          if (res.data.response == 0) {
            return this.$message.error('已没有商品可进行退款/退货!')
          }
          this.dialogSkuNumber = true
          this.balanceCanRefundNum = res.data.response || 1
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getIsJoinChannelFullReduce() {
      CalculateRefundAmount(this.needData).then(res => {
        if (res.data.success) {
          this.dialogSkuNumber = false
          if (this.needData.operateType == 1) {
            this.returnVisible = true;
          } else {
            this.applyReturnVisible = true;
          }
          this.fullReduceData = res.data.response || {}
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getMainOrderDetail() {
      let that = this;
      let param = {
        path: 'MainOrder/Detail',
        parms: '',
        parmsJson: {
          mainOrderId: that.$route.query.orderid
        }
      };
      KSAXApiRequest(param).then((res) => {
        that.orderDetailData = res.data.response;
        that.orderDetailData.picInfoList = res.data.response.picInfoList || []
        that.orderDetailData.receiverAddress =
          res.data.response.receiverAddress;
        let list = [];
        list[0] = {
          payTradeNo: res.data.response.payTradeNo,
          totalAmount: res.data.response.totalAmount,
          shippingFee: res.data.response.shippingFee,
          couponAmount: res.data.response.couponAmount,
          envelopeAmount: res.data.response.envelopeAmount,
          points: res.data.response.points,
          pledgeAmount: res.data.response.pledgeAmount,
          fullReduceAmount: res.data.response.fullReduceAmount,
          memberDiscountAmount: res.data.response.memberDiscountAmount,
          productDiscountAmount: res.data.response.productDiscountAmount,
          amount: res.data.response.amount,
          isPaid: res.data.response.isPaid,
          payType: res.data.response.payType,
          payTime: res.data.response.payTime,
          earnestMoney: res.data.response.earnestMoney,
          finalAmount: res.data.response.finalAmount,
          paidFinalAmount: res.data.response.paidFinalAmount,
          multipleDiscountAmount: res.data.response.multipleDiscountAmount,
          deductibleMemberRebateAmount: res.data.response.deductibleMemberRebateAmount,
        };
        let storageFee = Number(res.data.response.lccwStorageFee)
        if (storageFee >= 0) {
          list[0]['lccwStorageFee'] = storageFee
        }
        that.tableData = list;
      });
    },
    getAfterSaleOrderList() {
      this.getMainOrderDetail();
    },
    goBack() {
      this.$router.go(-1);
    },
    /*子订单列表*/
    getChildList() {
      let that = this;
      let param = {
        path: 'MainOrder/ChildList',
        parms: '',
        parmsJson: {
          mainOrderId: that.$route.query.orderid,
          supId: that.$route.query.supId
        }
      };
      let list = [];
      KSAXApiRequest(param).then((res) => {
        list = res.data.response;
        list.forEach((v, i) => {
          if (v.afterSaleCheckStatus == 1 || v.afterSaleCheckStatus == 2 || v.status == 10 || v.status == 60 || v.status == 70) {
            v.isShowAfterSaleCheck = false;
          } else {
            v.isShowAfterSaleCheck = true
          }
          if (!v.afterSaleList || !v.afterSaleList[0]) {
            v.isShowBtn = true;
          } else {
            // v.afterSaleList.forEach((v1, i1) => {
            //   if (v1.businessStatus == 2 || v1.financeStatus == 2) {
            //     v.isShowBtn = true;
            //   } else {
            //     v.isShowBtn = false;
            //   }
            // });
            if (v.afterSaleList[0].businessStatus == 2 || v.afterSaleList[0].financeStatus == 2) {
              v.isShowBtn = true;
            } else {
              v.isShowBtn = false;
            }
          }
        });
        that.childOrderList = list;
        that.subChildOrder.orderNo = list[0].childOrderNo;
      });
    },
    //获取省
    getProvinceList() {
      let that = this;
      let params = {
        areaLevel: 1,
      };
      areaList(params).then((res) => {
        that.provinceList = res.data.response.data;
        if (that.orderDetailData.receiverProvinceId) {
          that.getCityList();
        }
      });
    },
    //获取市
    getCityList() {
      let that = this;
      let params = {
        areaLevel: 2,
        parentId: that.orderDetailData.receiverProvinceId,
      };
      areaList(params).then((res) => {
        that.cityList = res.data.response.data;
        if (that.orderDetailData.receiverCityId) {
          that.getAreaList();
        }
      });
    },
    //获取区
    getAreaList(areaId) {
      let that = this;
      let params = {
        areaLevel: 3,
        parentId: that.orderDetailData.receiverCityId,
      };
      areaList(params).then((res) => {
        that.areaList = res.data.response.data;
      });
    },
    //选择省市区
    handleProvince(e) {
      this.orderDetailData.receiverProvinceId = e.Id;
      this.orderDetailData.receiverProvinceName = e.AreaName;
      this.orderDetailData.receiverCityId = null;
      this.orderDetailData.receiverCityName = null;
      this.orderDetailData.receiverDistrictId = null;
      this.orderDetailData.receiverDistrictName = null;
      this.getCityList();
    },
    handleCity(e) {
      this.orderDetailData.receiverCityId = e.Id;
      this.orderDetailData.receiverCityName = e.AreaName;
      this.orderDetailData.receiverDistrictId = null;
      this.orderDetailData.receiverDistrictName = null;
      this.getAreaList();
    },
    handleArea(e) {
      this.orderDetailData.receiverDistrictId = e.Id;
      this.orderDetailData.receiverDistrictName = e.AreaName;
    },
    handleBack() {
      this.$router.back();
    },
    onCopy(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    // 复制失败时的回调函数
    onError(e) {
      this.$message.error("抱歉，复制失败！");
    },
    async sendMessage(row) {
      this.showHaiXinData = '';
      let params = { childOrderId: row.childOrderId };
      let res = await GetHxRecordInfo(params);
      if (!res.data.success) {
        this.$message.error(res.data.msg || '获取信息失败,请重试');
      }
      if (!res.data && !res.data.response && !res.data.response.IsSend) {
        return this.$message.error('暂无推送信息')
      }
      this.showHaiXinData = res.data.response;
      this.isHaiXinShow = true;
    },
    synchronouBtn() {
      GetMeidiOrder().then(res => {
        this.$message.success('操作成功！')
      })
    },
    // 发货
    handleSend(row) {
      this.dialogVisible = true;
      this.logForm.childOrderId = row.childOrderId;
      logisticsCompanyAllList().then((res) => {
        this.logisticsList = res.data.response;
      });
    },
    //修改物流
    handleRevise(row) {
      this.reviseVisible = true;
      this.reviseForm.orderLogisticsId = row.Id;
      this.reviseForm.sendSkuNumer = row.sendSkuNumer;
      this.reviseForm.outChildOrderNo = row.outChildOrderNo
      this.reviseForm.logisticsCode = row.logisticsCode
      this.reviseForm.logisticsCompanyId = row.logisticsCompanyId
      logisticsCompanyAllList().then((res) => {
        this.logisticsList = res.data.response;
      });
    },
    //修改物流
    handleReviseSubmit() {
      let that = this;
      that
        .$confirm("确认修改, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          reviseLogistics(that.reviseForm).then((res) => {
            if (res.data.success) {
              that.$message.success("修改成功！");
              that.reviseVisible = false;
              that.getChildList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    //发货
    handleSendSubmit() {
      let that = this;
      if (!that.logForm.logisticsCompanyId)
        return that.$message.error("请选择物流公司");
      if (!that.logForm.logisticsCode || that.logForm.logisticsCode == "")
        return that.$message.error("请输入物流单号");
      that
        .$confirm("确认发货, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          let data = {
            path: 'ChildOrder/ChildSupShip',
            parms: '',
            parmsJson: that.logForm
          }
          KSAXApiRequest(data).then((res) => {
            if (res.data.success) {
              that.$message.success(res.data.msg);
              that.dialogVisible = false;
              that.getChildList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    //查看物流
    handleLookLog(row) {
      if (row.logisticsCompanyName.includes('安得物流')) {
        return window.open(`https://www.annto.com/mobile/order?orderNoFormMain=${row.logisticsCode}`)
      }
      var that = this;
      that.showLogVisible = true;
      var params = {
        // orderLogisticsId: row.Id,
        logisticsCompanyId: row.logisticsCompanyId,
        logisticsCode: row.logisticsCode,
      };
      GetOrderLogisticsKSAX(params).then((res) => {
        if (res.data.success) {
          that.logDescriptionList = res.data.result.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleAnnexLog(str) {
      this.annexList = JSON.parse(str)
      this.dialogAnnexLogistics = true
    },
    //确认收货
    confirmGoods(row) {
      let that = this;
      that
        .$confirm("确认收货, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          var param = {
            childOrderIds: row.childOrderId,
          };
          receipt(param).then((res) => {
            if (res.data.success) {
              that.$message.success("收货成功！");
              that.getChildList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    //退款
    handleRefund(row, i) {
      this.receiveRow = row;
      this.returnForm.applySkuId = row.SkuId;
      this.returnForm.childOrderId = row.childOrderId;
      this.returnForm.refundAmount = 0
      this.returnForm.reason = ''
      this.needData.childOrderNo = row.childOrderNo
      this.needData.operateType = i
      this.getBalanceCanRefundNum(row)
    },
    // testRefundAmount(e) {
    //   if (e <= 0.01) {
    //     this.returnForm.refundAmount = 0.01;
    //   }
    //   // else if (e > this.fullReduceData.actualRefundAmount) {
    //   //   this.returnForm.refundAmount = this.fullReduceData.actualRefundAmount;
    //   // }
    // },
    //退款
    handleReturnSubmit() {
      let that = this;
      if (that.returnForm.reason == "")
        return that.$message.error("请输入理由！");
      // if (that.returnForm.refundAmount == 0)
      //   return that.$message.error("退款金额不能为零！");
      that
        .$confirm("确认退款？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          this.returnForm.applySkuNumber = this.fullReduceData.applySkuNumber
          this.returnForm.refundAmount = this.fullReduceData.actualRefundAmount
          applyRefund(that.returnForm).then((res) => {
            if (res.data.success) {
              that.$message.success("提交成功！");
              that.returnVisible = false;
              that.getChildList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    giftDetail(item) {
      var data = {
        childOrderNo: item.childOrderNo,
      };
      GetGiftRecordDatas(data).then((res) => {
        if (res.data.response) {
          this.showGiftLayer = true;
          this.giftList = res.data.response;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 退货
    //
    //
    handleReturn(row, i) {
      this.returnRow = row;
      this.applyReturnForm.childOrderId = row.childOrderId;
      this.applyReturnForm.applySkuId = row.SkuId;
      this.applyReturnForm.refundAmount = 0
      this.applyReturnForm.reason = ''
      this.needData.childOrderNo = row.childOrderNo
      this.needData.operateType = i
      this.getBalanceCanRefundNum(row)
    },
    // testReturnAmount(e) {
    //   if (e < 0) {
    //     this.applyReturnForm.refundAmount = 0;
    //   }
    //   // else if (e > this.fullReduceData.actualRefundAmount) {
    //   //   this.applyReturnForm.refundAmount = this.fullReduceData.actualRefundAmount;
    //   // }
    // },
    handleApplyReturnSubmit() {
      let that = this;
      if (that.applyReturnForm.reason == "" || !that.applyReturnForm.reason)
        return that.$message.error("请输入退货备注！");
      // if (that.applyReturnForm.refundAmount == 0)
      //   return that.$message.error("请输入退货退款金额！");
      that
        .$confirm("确认退货？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          that.applyReturnForm.applySkuNumber = that.fullReduceData.applySkuNumber
          this.applyReturnForm.refundAmount = this.fullReduceData.actualRefundAmount
          applyReturn(that.applyReturnForm).then((res) => {
            if (res.data.success) {
              that.$message.success("提交成功！");
              that.applyReturnVisible = false;
              that.getChildList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },

    //换货
    exchangeGoods(row) {
      this.changeRow = row;
      this.changeForm.childOrderId = row.childOrderId;
      this.changeForm.applySkuId = row.SkuId;
      this.applyChangeVisible = true;
    },
    testChangeNumber(e) {
      if (e < 0) {
        this.changeForm.applySkuNumber = 1;
      } else if (e > this.changeRow.skuNumber) {
        this.changeForm.applySkuNumber = this.changeRow.skuNumber;
      }
    },
    handleChangeSubmit() {
      let that = this;
      if (that.changeForm.reason == "" || !that.changeForm.reason)
        return that.$message.error("请输入换货备注！");
      that
        .$confirm("确认换货？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          applyChange(that.changeForm).then((res) => {
            if (res.data.success) {
              that.$message.success("提交成功！");
              that.applyChangeVisible = false;
              that.getChildList();
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },

    handleClick() {
      let that = this;
      if (that.activeName == "second") {
        let params = {
          mainOrderId: that.$route.query.orderid,
          PageIndex: that.pageIndex,
          PageSize: that.pageSize,
        };
        mainOrderTrack(params).then((res) => {
          that.trackList = res.data.response.data;
          that.total = res.data.response.dataCount;
        });
      } else if (that.activeName == "third") {
        let params = {
          mainOrderId: that.$route.query.orderid,
          PageIndex: that.pageIndex,
          PageSize: that.pageSize,
        };
        purList(params).then((res) => {
          that.purRecList = res.data.response.data;
          that.total = res.data.response.dataCount;
        });
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.handleClick();
    },
    callFunction(item) {
      this[item.Func]();
    },
    handleSubmit() {
      let that = this;
      that
        .$confirm("确定修改, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        })
        .then(() => {
          let parmas = {
            mainOrderId: that.$route.query.orderid,
            receiverName: that.orderDetailData.receiverName,
            receiverPhone: that.orderDetailData.receiverPhone,
            receiverProvinceId: that.orderDetailData.receiverProvinceId,
            receiverProvinceName: that.orderDetailData.receiverProvinceName,
            receiverCityId: that.orderDetailData.receiverCityId,
            receiverCityName: that.orderDetailData.receiverCityName,
            receiverDistrictId: that.orderDetailData.receiverDistrictId,
            receiverDistrictName: that.orderDetailData.receiverDistrictName,
            receiverAddress: that.orderDetailData.receiverAddress,
            businessRemark: that.orderDetailData.businessRemark,
            remark: that.orderDetailData.remark,
            picInfoList: that.orderDetailData.picInfoList
          };
          editMainOrder(parmas).then((res) => {
            if (res.data.success) {
              that.$message.success(res.data.msg);
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    },
    goDetail(item) {
      this.itemData = item;
    },
    setSubOrderStatus(item) {
      this.subChildOrder.orderNo = item;
      this.subOrderVisible = true;
    },
    async subOrderConfirm() {
      this.subOrderVisible = false;
      // if (this.subChildOrder.status !== 30) {
      //   delete this.subChildOrder.isBonus;
      // }
      let res = await ChangeOrderStatus(this.subChildOrder);
      if (res.data.success) {
        this.$message.success('设置成功');
        this.getChildList();
      } else {
        this.$message.error(res.data.msg || '设置失败, 请重试');
      }
    },
    subOrderClose() {
      this.subOrderVisible = false;
      this.subChildOrder.orderNo = '';
      this.subChildOrder.status = '';
    },
    selectSubOrderStatus(val) {
      if (Number(val) === 50) {
        this.isSubOrderChoseShow = true;
      } else {
        this.isSubOrderChoseShow = false;
      }
    }
  },
  mounted() {
    let that = this;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.ButtonType === 10 && item.Func !== 'compensate' && item.Func !== 'returnBean';
    });
    this.buttonList_toolBar = toolBarButtonList;
    var compensateBtn = buttonList.findIndex(i => {
      return i.Func === 'compensate'
    })
    if (compensateBtn > -1) {
      this.isCompensateBtn = true
    }
    var buttonList1 = getButtonList(
      "/Order/OrderManagement/OrderDetailChild",
      routers
    );
    var buttonList2 = getButtonList(
      "/Order/OrderManagement/SubOrderDetail",
      routers
    );
    buttonList2.forEach((v, i) => {
      if (v.Func == "subOrderConfirm") {
        that.isSubOrderShow = true;
      }
      if (v.Func == "returnBean") {
        that.isCanReturnBean = true;
      }
    });
    buttonList1.forEach((v, i) => {
      if (v.Func == "handleDeliver") {
        that.isShowDeliver = true;
      } else if (v.Func == "handleRefund") {
        that.isShowRefund = true;
      } else if (v.Func == "handleConfirm") {
        that.isShowConfirm = true;
      } else if (v.Func == "handleReturn") {
        that.isShowReturn = true;
      } else if (v.Func == "handleRevise") {
        that.isShowRevise = true;
      } else if (v.Func == "handleLookLog") {
        that.isShowLookLog = true;
      } else if (v.Func == "handleExchange") {
        that.isShowExchange = true;
      } else if (v.Func == "giftDetail") {
        that.isShowGiftDetail = true;
      }
    });
  },
};
</script>

<style scoped>
.flex-wrap {
  display: flex;
}

.flex-1 {
  flex: 1;
}

.flex-center {
  align-items: center;
}

.flex-col {
  flex-direction: column;
}

.flex-sb {
  justify-content: space-between;
}

.main_index {
  overflow: hidden;
}

.detail_main {
  padding: 0 20px;
}

.row_array {
  margin-bottom: 0;
}

.header_tit {
  height: 30px;
  width: 100%;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  display: flex;
  align-items: center;
  padding: 20px 0;
}

.header_tit .red_box {
  width: 4px;
  height: 14px;
  border-radius: 2px;
  margin-right: 10px;
  background: linear-gradient(0deg, rgba(242, 64, 93, 1), rgba(238, 52, 83, 1));
}

.el-page-header {
  margin-bottom: 20px;
}

.sub_order {
  width: 100%;
  padding: 10px 20px;
}

.child_detail {
  width: 100%;
  overflow-x: scroll;
  display: flex;
  justify-content: flex-start;
}

.child_detail_info {
  background-color: #fafafa;
  width: 420px;
  border-radius: 15px;
  padding: 20px 10px;
  margin-left: 10px;
  height: auto;
  display: inline-table;
}

.info_tit {
  font-weight: 600;
  padding: 10px;
  border-top: 1px solid #d8d8d8;
}

.sup-box {
  width: 400px;
  border-top: 1px solid #d8d8d8;
  padding: 10px 0;
}

.log-box {
  border-top: 1px solid #d8d8d8;
  margin-left: 20px;
  margin-top: 10px;
  padding: 10px 0;
}

.item_li {
  border-bottom: 1px solid #eee;
  padding: 10px;
  font-size: 20px;
}

.el-input {
  width: 300px;
}

.img_box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.bg_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

.bg_box:hover {
  opacity: 1;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.messageList-text {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #333333;
  padding: 10px;
}

.message-richText>>>img {
  max-width: 200px !important;
  display: block !important;
}

.message-richText>>>video {
  max-width: 200px !important;
}

.messageList-product {
  width: 300px;
  background: #F5F9FD;
  border-radius: 10px;
  padding: 12px;
}

.messageList-product-img {
  width: 60px;
  height: 60px;
  border-radius: 5px;
  margin-right: 10px;
}

.messageList-product-proName {
  font-size: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #111111;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.messageList-product-price {
  font-size: 14px;
  font-family: PingFang-SC, PingFang-SC;
  font-weight: 800;
  color: #111111;
}

.message-order-childOrderNo {
  font-size: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #666666;
}

.message-order-statusDesc {
  font-size: 12px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #FF3B25;
}
</style>
